import React from "react";
//import logo from "./logo.svg";
import "./App.css";
import BeerMenu from "./components/BeerMenu";

function App() {
  return (
    <div className="App bg-stone-900 min-h-screen">
      <BeerMenu />
    </div>
  );
}

export default App;
